// extracted by mini-css-extract-plugin
export default {"zoomModal":"M3-z","image":"N3-z","button":"O3-z","isOverlayShown":"P3-z"};